module.exports = __webpack_public_path__ + "static/media/img2.e981619f.svg";